export type SupportType = 'technical' | 'financial'

export type SupportRecipient = {
  email: string
  label: string
}

export const SUPPORT_RECIPIENTS: SupportRecipient[] = [
  { email: 'matthieu@voxist.com', label: 'Matthieu' },
  { email: 'karel@voxist.com', label: 'Karel' }
]

export type SupportTypeConfig = {
  id: SupportType
  label: string
  description: string
  subjectTag: string
  defaultTo: string[]
  defaultCc: string[]
  notesTemplate: string
}

export const SUPPORT_TYPES: SupportTypeConfig[] = [
  {
    id: 'technical',
    label: 'Technical',
    description:
      'API, voicemail, transcription, login, app crashes, sync issues.',
    subjectTag: 'Tech support',
    defaultTo: ['matthieu@voxist.com'],
    defaultCc: ['karel@voxist.com'],
    notesTemplate: `Issue:
-

Steps tried:
-

Expected behavior:
-

Affected feature / area:
- `
  },
  {
    id: 'financial',
    label: 'Financial',
    description:
      'Billing, invoices, plan changes, refunds, transcription credits.',
    subjectTag: 'Finance support',
    defaultTo: ['matthieu@voxist.com'],
    defaultCc: ['karel@voxist.com'],
    notesTemplate: `Issue:
-

Account / billing context:
-

Expected outcome:
-

Last invoice / charge reference:
- `
  }
]
